import React, { useState } from 'react';
import { REGION } from '../data/bavariaHolidays';

function Footer() {
  const [legal, setLegal] = useState(null);

  return (
    <footer className="footer">
      <p><strong>Eine positive Initiative von CBUY.EXPERT</strong></p>
      <p>
        Ferientermine: {REGION.source}. Angaben ohne Gewähr.
        {' '}
        <a href={REGION.sourceUrl} target="_blank" rel="noreferrer">Zur offiziellen Quelle</a>
      </p>
      <p>Die Prozentanzeige ist eine motivierende zeitliche Darstellung und keine Lohnabrechnung.</p>
      <nav aria-label="Rechtliche Informationen">
        <button type="button" onClick={() => setLegal('imprint')}>Impressum</button>
        <button type="button" onClick={() => setLegal('privacy')}>Datenschutz</button>
      </nav>

      {legal && (
        <div className="legal-note" role="dialog" aria-modal="true" aria-label={legal === 'imprint' ? 'Impressum' : 'Datenschutz'}>
          <h2>{legal === 'imprint' ? 'Impressum' : 'Datenschutz'}</h2>
          {legal === 'imprint' ? (
            <p>Vor der öffentlichen Veröffentlichung sind hier die rechtlich erforderlichen Angaben des verantwortlichen Anbieters einzutragen.</p>
          ) : (
            <p>Diese Version nutzt keine Anmeldung, keine Analyse-Cookies und keine Werbetracker. Vorname, Arbeitstage und bereits gezeigte Freudenmomente bleiben ausschließlich im lokalen Speicher dieses Geräts.</p>
          )}
          <button className="button button-primary" type="button" onClick={() => setLegal(null)}>Schließen</button>
        </div>
      )}
    </footer>
  );
}

export default Footer;